import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOnfidoFailed = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 72,
	height: 72,
	viewBox: "0 0 72 72",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 72,
			height: 72,
			rx: 9,
			fill: "#FFEBC4"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11.5,
			y: 21.4999,
			width: 41,
			height: 29,
			rx: 3,
			stroke: "#C43A00",
			strokeWidth: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31 44C31 40.6863 28.0899 38 24.5 38C20.9101 38 18 40.6863 18 44",
			stroke: "#C43A00",
			strokeWidth: 3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M24.5 34C26.433 34 28 32.433 28 30.5C28 28.567 26.433 27 24.5 27C22.567 27 21 28.567 21 30.5C21 32.433 22.567 34 24.5 34Z",
			stroke: "#C43A00",
			strokeWidth: 3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 35.75,
			y: 33.75,
			width: 10.5,
			height: 1.5,
			rx: .75,
			stroke: "#C43A00",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-6-inside-1_16491_21103",
			fill: "white",
			children: /* @__PURE__ */ _jsx("path", { d: "M35 28.5C35 27.6716 35.6716 27 36.5 27H41C41.8284 27 42.5 27.6716 42.5 28.5V28.5C42.5 29.3284 41.8284 30 41 30H36.5C35.6716 30 35 29.3284 35 28.5V28.5Z" })
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.5 30H41V24H36.5V30ZM41 27H36.5V33H41V27ZM36.5 27C37.3284 27 38 27.6716 38 28.5H32C32 30.9853 34.0147 33 36.5 33V27ZM39.5 28.5C39.5 27.6716 40.1716 27 41 27V33C43.4853 33 45.5 30.9853 45.5 28.5H39.5ZM41 30C40.1716 30 39.5 29.3284 39.5 28.5H45.5C45.5 26.0147 43.4853 24 41 24V30ZM36.5 24C34.0147 24 32 26.0147 32 28.5H38C38 29.3284 37.3284 30 36.5 30V24Z",
			fill: "#C43A00",
			mask: "url(#path-6-inside-1_16491_21103)"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-8-inside-2_16491_21103",
			fill: "white",
			children: /* @__PURE__ */ _jsx("path", { d: "M35 40.5C35 39.6716 35.6716 39 36.5 39H45.5C46.3284 39 47 39.6716 47 40.5V40.5C47 41.3284 46.3284 42 45.5 42H36.5C35.6716 42 35 41.3284 35 40.5V40.5Z" })
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.5 42H45.5V36H36.5V42ZM45.5 39H36.5V45H45.5V39ZM36.5 39C37.3284 39 38 39.6716 38 40.5H32C32 42.9853 34.0147 45 36.5 45V39ZM44 40.5C44 39.6716 44.6716 39 45.5 39V45C47.9853 45 50 42.9853 50 40.5H44ZM45.5 42C44.6716 42 44 41.3284 44 40.5H50C50 38.0147 47.9853 36 45.5 36V42ZM36.5 36C34.0147 36 32 38.0147 32 40.5H38C38 41.3284 37.3284 42 36.5 42V36Z",
			fill: "#C43A00",
			mask: "url(#path-8-inside-2_16491_21103)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M52.815 32.63C57.6834 32.63 61.63 28.6834 61.63 23.815C61.63 18.9466 57.6834 15 52.815 15C47.9466 15 44 18.9466 44 23.815C44 28.6834 47.9466 32.63 52.815 32.63Z",
			fill: "#C43A00"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M54 20C54 19.4477 53.5523 19 53 19C52.4477 19 52 19.4477 52 20V25C52 25.5523 52.4477 26 53 26C53.5523 26 54 25.5523 54 25V20ZM53 29C53.5523 29 54 28.5523 54 28C54 27.4477 53.5523 27 53 27C52.4477 27 52 27.4477 52 28C52 28.5523 52.4477 29 53 29Z",
			fill: "white"
		})
	]
});
export default SvgOnfidoFailed;
